/**
 * 测评管理 JSON 字段：校验与格式化（2 空格缩进）
 */

export function formatExamJsonField(raw) {
  const text = (raw ?? '').trim()
  if (!text) return ''
  const parsed = JSON.parse(text)
  return JSON.stringify(parsed, null, 2)
}

/**
 * @param {string} raw
 * @param {string} fieldLabel
 * @param {{ allowEmpty?: boolean }} opts
 */
export function validateExamJsonField(raw, fieldLabel = 'JSON', opts = {}) {
  const { allowEmpty = true } = opts
  const text = (raw ?? '').trim()
  if (!text) {
    if (allowEmpty) {
      return { ok: true, value: '' }
    }
    return { ok: false, message: `${fieldLabel}不能为空` }
  }
  try {
    return { ok: true, value: formatExamJsonField(text) }
  } catch (e) {
    return {
      ok: false,
      message: `${fieldLabel}不是合法 JSON：${e?.message || '解析失败'}`
    }
  }
}

/** 提交前格式化 exam 对象内所有 JSON 字段（不含 questions，由后端生成） */
export function normalizeExamJsonFields(exam) {
  const fields = [
    ['feedbacks', '测评反馈', true],
    ['summarys', '测评总结', true],
    ['questionKeys', '题目 Key 集合', true],
    ['originalQuestions', '原始题目', false],
    ['stops', '试题中断提示', true]
  ]
  const out = { ...exam }
  for (const [key, label, allowEmpty] of fields) {
    const result = validateExamJsonField(out[key], label, { allowEmpty })
    if (!result.ok) {
      throw new Error(result.message)
    }
    out[key] = result.value
  }
  return out
}
